import React, { useEffect, useState } from 'react';
import { Bar } from "react-chartjs-2";
import {
 Chart,
 CategoryScale,
 LinearScale,
 BarElement,
 Tooltip,
 Legend,
} from "chart.js";

Chart.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const PromotionsTimeDistribution = ({ r_data }) => {
 const [pageData, setPageData] = useState([]);

 useEffect(() => {
  setPageData(r_data || []);
 }, [r_data]);

 // Sort by time (important for correct order)
 const sortedData = [...pageData]?.sort((a, b) => {
  const getStartHour = (range) => parseInt(range?.split("-")[0]);
  return getStartHour(a?.time_range) - getStartHour(b?.time_range);
 });

 const labels = sortedData?.map(d => d?.time_range);
 const values = sortedData?.map(d => d?.count);

 // Peak detection (nice UX addition)
 const peak = sortedData.reduce(
  (max, curr) => (curr?.count > (max?.count || 0) ? curr : max),
  {}
 );

 const data = {
  labels,
  datasets: [
   {
    label: "Entries",
    data: values,
    backgroundColor: "rgba(13, 110, 253, 0.6)",
    borderRadius: 6,
    barThickness: 28
   }
  ]
 };

 return (
  <div style={{ background: "#fff", padding: "16px", borderRadius: "10px" }}>

   {/* Header */}
   <div style={{ marginBottom: "12px" }}>
    <h6 style={{ marginBottom: "4px", fontWeight: 600 }}>
     Time Distribution
    </h6>

    {peak?.time_range && (
     <small style={{ color: "#6c757d" }}>
      Peak: <strong>{peak.time_range}</strong> ({peak.count} entries)
     </small>
    )}
   </div>

   {/* Chart */}
   <div style={{ height: "260px" }}>
    <Bar
     data={data}
     options={{
      maintainAspectRatio: false,
      plugins: {
       legend: { display: false },
       tooltip: {
        callbacks: {
         label: (context) => `${context.parsed.y} entries`
        }
       }
      },
      scales: {
       y: {
        beginAtZero: true,
        ticks: { color: "#6c757d", font: { size: 11 } },
        grid: { color: "rgba(0,0,0,0.05)" }
       },
       x: {
        ticks: { color: "#6c757d", font: { size: 10 } },
        grid: { display: false }
       }
      }
     }}
    />
   </div>
  </div>
 );
};

export default PromotionsTimeDistribution;